import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromUserAccounts from './+state/user-accounts.reducer'
import { UserAccountsEffects } from './+state/user-accounts.effects'
import { UserAccountsFacade } from './+state/user-accounts.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromUserAccounts.USER_ACCOUNTS_FEATURE_KEY, fromUserAccounts.userAccountsReducer),
    EffectsModule.forFeature([UserAccountsEffects]),
  ],
  providers: [UserAccountsFacade],
})
export class GbDashboardStaffDataAccessUserAccountsModule {}
